import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const categoryData = [
  { key: "shoes", nameKey: "category_shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20sneakers%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shoe%20shot&width=112&height=112&seq=nav-cat-shoes&orientation=squarish" },
  { key: "hoodies", nameKey: "category_hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20hoodie%20sweater%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-hoodies&orientation=squarish" },
  { key: "tshirts", nameKey: "category_tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20t-shirt%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-tshirts&orientation=squarish" },
  { key: "jackets", nameKey: "category_jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20jacket%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-jackets&orientation=squarish" },
  { key: "pants", nameKey: "category_pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20pants%20trousers%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-pants&orientation=squarish" },
  { key: "headwear", nameKey: "category_headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20cap%20hat%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-headwear&orientation=squarish" },
  { key: "sets", nameKey: "category_sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20matching%20set%20outfit%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-sets&orientation=squarish" },
  { key: "underwear", nameKey: "category_underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20underwear%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-underwear&orientation=squarish" },
  { key: "jersey", nameKey: "category_jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20sports%20jersey%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-jersey&orientation=squarish" },
  { key: "accessories", nameKey: "category_accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20fashion%20accessories%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20shot&width=112&height=112&seq=nav-cat-accessories&orientation=squarish" },
  { key: "bags", nameKey: "category_bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20bag%20handbag%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-bags&orientation=squarish" },
  { key: "belts", nameKey: "category_belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20belt%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20fashion%20shot&width=112&height=112&seq=nav-cat-belts&orientation=squarish" },
  { key: "perfumes", nameKey: "category_perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20perfume%20bottle%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20beauty%20shot&width=112&height=112&seq=nav-cat-perfumes&orientation=squarish" },
  { key: "other", nameKey: "category_other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", imageUrl: "https://readdy.ai/api/search-image?query=High%20quality%20various%20fashion%20items%20product%20photography%20on%20clean%20white%20background%20minimalist%20studio%20lighting%20professional%20ecommerce%20shot&width=112&height=112&seq=nav-cat-other&orientation=squarish" },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const hamburgerRef = useRef<HTMLButtonElement>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if (hamburgerRef.current && hamburgerRef.current.contains(target)) {
        return;
      }
      if (dropdownRef.current && !dropdownRef.current.contains(target)) {
        setDropdownOpen(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(target)) {
        setMobileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
    setDropdownOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-label text-lg md:text-xl font-bold tracking-tight text-foreground-950">
              yoybuy<span className="text-primary-600">.asia</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t("categories_all")}
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-3 left-1/2 -translate-x-1/2 bg-background-50 rounded-2xl p-5 w-[680px] grid grid-cols-4 gap-2 z-50 border border-background-200/70">
                  {categoryData.map((cat) => (
                    <a
                      key={cat.key}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group"
                    >
                      <div className="w-14 h-14 rounded-xl bg-background-100 overflow-hidden flex-shrink-0">
                        <img
                          src={cat.imageUrl}
                          alt={t(cat.nameKey)}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                        {t(cat.nameKey)}
                      </span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("nav_yoybuy_sheet")}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("nav_buy_now")}
            </a>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-3 py-1.5 bg-primary-500 text-background-50 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap"
            >
              {t("nav_yoybuy_sheet")}
            </a>
            <button
              ref={hamburgerRef}
              onClick={handleMobileToggle}
              className="w-9 h-9 flex items-center justify-center cursor-pointer"
            >
              <i className={`text-xl text-foreground-800 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div ref={mobileMenuRef} className="md:hidden pb-4 bg-background-50/95 backdrop-blur-md border-t border-background-200/70">
            <div className="grid grid-cols-2 gap-1 pt-3">
              {categoryData.map((cat) => (
                <a
                  key={cat.key}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span className="text-xs font-medium text-foreground-700">{t(cat.nameKey)}</span>
                </a>
              ))}
            </div>
            <div className="pt-3 px-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block w-full text-center px-4 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap"
              >
                {t("nav_buy_now")}
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}